import ReactDOM from 'react-dom/client';
import '@/index.css';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Routes from './Routes';
import { Toaster } from './components/ui/toaster';
import { NavigationBlockerProvider } from '@/context/NavigationBlockerContext';
import StatusBar from './components/StatusBar';
import { registerSessionHandlers } from '@/services/inactivityTimeOut';

registerSessionHandlers();

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  // <React.StrictMode>
  <NavigationBlockerProvider>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={Routes} />
      <StatusBar />
      <Toaster />
    </QueryClientProvider>
  </NavigationBlockerProvider>
  // </React.StrictMode>
);
